<div class="fullcontainer" >
    <br />
    <br />
  
    <div class='titleContainer'>
      <h2 class='header' style='color: #006498'>Invoice Email History</h2>
    </div>
    <br />
    <br />
    <app-grid
  entity='invoice-email-log'
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFilters'
  [searchFields]='this.searchFields'
  [relationships]='["invoice", "invoice.account"]'
  ></app-grid>
  